import { useCopyToClipboard } from '../../helpers'
import { Icon } from '../Icon'
import ActionButton, { IActionButtonProps } from './ActionButton'

export interface ICopyButtonProps extends Omit<IActionButtonProps, 'action' | 'onClick' | 'icon'> {
  /** O texto que vai para a área de transferência. */
  value: string
  /** O que está sendo copiado, minúsculo: vira o rótulo (`Copiar link`) e a frase do toast. */
  entity?: string
  /** Concordância pt-BR: ligue para substantivo feminino (`URL copiada`). */
  feminine?: boolean
  /** Descrição do toast nos dois desfechos — o próprio valor, quando ele é curto e legível. */
  description?: string
}

/**
 * Botão de copiar do painel: o `ActionButton action="copy"` com o `useCopyToClipboard` dentro.
 *
 * O ícone vira um check enquanto `copied`, que é o que o `HeroLinkButton` já fazia sozinho e
 * nenhum dos outros oito gatilhos de cópia fazia — o estado "copiado" tinha três nomes e três
 * aparências no painel, e 8 dos 15 sites não davam retorno nenhum.
 *
 * A intenção ainda é declarada por `entity`: ela escreve o rótulo do botão e a frase do toast,
 * então o tooltip e a notificação não podem divergir.
 */
export default function CopyButton({ value, entity, feminine, description, label, ...rest }: ICopyButtonProps) {
  const { copied, copy } = useCopyToClipboard()

  return (
    <ActionButton
      action="copy"
      label={copied ? 'Copiado' : (label ?? (entity ? `Copiar ${entity}` : undefined))}
      onClick={() => copy(value, { entity, feminine, description })}
      {...rest}
      // Cor de estado entra como spread condicional, e depois do `rest`: um
      // `colorScheme={copied ? ... : undefined}` explícito ainda sobrescreveria o do registry, e
      // a cor do estado tem que ganhar da cor que o call site escolheu para o repouso.
      {...(copied ? { icon: <Icon name="lni lni-checkmark" />, colorScheme: 'abraGreen' } : {})}
    />
  )
}
